<script lang="ts">
  import AdminDashboard from '../../components/admin/dashboard/AdminDashboard.svelte';
</script>

<div class="admin-dashboard-page">
  <AdminDashboard />
</div>

<style>
  .admin-dashboard-page {
    min-height: 100vh;
    background-color: #f9fafb;
  }
</style> 